import React from "react";

const SocialManager = () => {
  return <div>SocialManager</div>;
};

export default SocialManager;
